// @ts-nocheck THIS IS A GENERATED FILE, DO NOT EDIT
import * as PrivateSchemaTypes from '../../../../graphql/private/PrivateSchemaTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from '@apolloHooksWithThrowingQuery';
const defaultOptions =  {}
export type SurveyParticipantsQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
  search?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.Scalars['String']>;
  order?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.SurveyManageUsersOverviewOrderColumn>;
  orderDirection?: PrivateSchemaTypes.Maybe<PrivateSchemaTypes.SqlOrderDirectionEnum>;
  limit: PrivateSchemaTypes.Scalars['PositiveInt'];
  offset: PrivateSchemaTypes.Scalars['NonNegativeInt'];
}>;


export type SurveyParticipantsQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'participantsCount'>
      & { participants: Array<(
        { __typename?: 'SurveyUserModel' }
        & Pick<PrivateSchemaTypes.SurveyUserModel, 'id' | 'survey_id' | 'invited_group_id' | 'sent_by' | 'created_at' | 'started_at' | 'completed_at'>
        & { user: (
          { __typename?: 'UserModel' }
          & Pick<PrivateSchemaTypes.UserModel, 'id' | 'userIdentity' | 'first_name' | 'last_name' | 'display_name' | 'image_url'>
        ) }
      )> }
    )> }
  )> }
);

export type SurveyParticipantsCountQueryVariables = PrivateSchemaTypes.Exact<{
  id: PrivateSchemaTypes.Scalars['PositiveInt'];
}>;


export type SurveyParticipantsCountQuery = (
  { __typename?: 'Query' }
  & { admin?: PrivateSchemaTypes.Maybe<(
    { __typename?: 'AdminViewerQueries' }
    & { survey?: PrivateSchemaTypes.Maybe<(
      { __typename?: 'SurveyModelAsAdmin' }
      & Pick<PrivateSchemaTypes.SurveyModelAsAdmin, 'id' | 'participantsCount'>
    )> }
  )> }
);


export const SurveyParticipantsDocument = gql`
    query surveyParticipants($id: PositiveInt!, $search: String, $order: SurveyManageUsersOverviewOrderColumn, $orderDirection: SQLOrderDirectionEnum, $limit: PositiveInt!, $offset: NonNegativeInt!) {
  admin {
    survey(id: $id) {
      id
      participantsCount
      participants(
        search: $search
        order: $order
        orderDirection: $orderDirection
        offset: $offset
        limit: $limit
      ) {
        id
        survey_id
        invited_group_id
        sent_by
        created_at
        started_at
        completed_at
        user {
          id
          userIdentity
          first_name
          last_name
          display_name
          image_url
        }
      }
    }
  }
}
    `;

/**
 * __useSurveyParticipantsQuery__
 *
 * To run a query within a React component, call `useSurveyParticipantsQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyParticipantsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyParticipantsQuery({
 *   variables: {
 *      id: // value for 'id'
 *      search: // value for 'search'
 *      order: // value for 'order'
 *      orderDirection: // value for 'orderDirection'
 *      limit: // value for 'limit'
 *      offset: // value for 'offset'
 *   },
 * });
 */
export function useSurveyParticipantsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>(SurveyParticipantsDocument, options);
      }
export function useSurveyParticipantsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>(SurveyParticipantsDocument, options);
        }
export type SurveyParticipantsQueryHookResult = ReturnType<typeof useSurveyParticipantsQuery>;
export type SurveyParticipantsLazyQueryHookResult = ReturnType<typeof useSurveyParticipantsLazyQuery>;
export type SurveyParticipantsQueryResult = Apollo.QueryResult<SurveyParticipantsQuery, SurveyParticipantsQueryVariables>;
export const SurveyParticipantsCountDocument = gql`
    query surveyParticipantsCount($id: PositiveInt!) {
  admin {
    survey(id: $id) {
      id
      participantsCount
    }
  }
}
    `;

/**
 * __useSurveyParticipantsCountQuery__
 *
 * To run a query within a React component, call `useSurveyParticipantsCountQuery` and pass it any options that fit your needs.
 * When your component renders, `useSurveyParticipantsCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSurveyParticipantsCountQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSurveyParticipantsCountQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SurveyParticipantsCountQuery, SurveyParticipantsCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SurveyParticipantsCountQuery, SurveyParticipantsCountQueryVariables>(SurveyParticipantsCountDocument, options);
      }
export function useSurveyParticipantsCountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SurveyParticipantsCountQuery, SurveyParticipantsCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SurveyParticipantsCountQuery, SurveyParticipantsCountQueryVariables>(SurveyParticipantsCountDocument, options);
        }
export type SurveyParticipantsCountQueryHookResult = ReturnType<typeof useSurveyParticipantsCountQuery>;
export type SurveyParticipantsCountLazyQueryHookResult = ReturnType<typeof useSurveyParticipantsCountLazyQuery>;
export type SurveyParticipantsCountQueryResult = Apollo.QueryResult<SurveyParticipantsCountQuery, SurveyParticipantsCountQueryVariables>;